module.exports = __webpack_public_path__ + "static/media/window.a01405a1.png";